<template>
  <section class="wrapper">
    <van-row class="mt10">
      <van-col :span="6">
        <van-button block size="small" :type="currentUrl==='mark'?'primary':'default'" @click="goto('mark')">记录付款</van-button>
      </van-col>
      <van-col :span="6">
        <van-button block size="small" :type="currentUrl==='searchPayment'?'primary':'default'"
                    @click="goto('search-payment')">
          查询付款与销账
        </van-button>
      </van-col>
      <van-col :span="6">
        <van-button block size="small" :type="currentUrl==='expend'?'primary':'default'" @click="goto('expend')">申请成本与支出
        </van-button>
      </van-col>
      <van-col :span="6">
        <van-button block size="small" :type="currentUrl==='searchExpend'?'primary':'default'" @click="goto('search-expend')">
          查询成本外支出
        </van-button>
      </van-col>
    </van-row>
    <router-view class="content"></router-view>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        currentUrl: ''
      }
    },
    methods: {
      goto(url) {
        this.$router.push(`/payment/${url}`)
      }
    },
    watch: {
      $route: {
        handler(to, from) {
          if (to.path.indexOf('mark') >= 0) {
            this.currentUrl = 'mark'
          } else if (to.path.indexOf('search-payment') >= 0) {
            this.currentUrl = 'searchPayment'
          } else if (to.path.indexOf('search-expend') >= 0) {
            this.currentUrl = 'searchExpend'
          } else if (to.path.indexOf('expend') >= 0) {
            this.currentUrl = 'expend'
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="less" scoped>
  .content {
    padding: 0 1rem;
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    height: calc(100% - 10rem);
    overflow: hidden;
  }

</style>
